import { render, staticRenderFns } from "./PedidoAcumuladoVsDespachado.vue?vue&type=template&id=94c4fcae&scoped=true&"
import script from "./PedidoAcumuladoVsDespachado.vue?vue&type=script&lang=js&"
export * from "./PedidoAcumuladoVsDespachado.vue?vue&type=script&lang=js&"
import style0 from "./PedidoAcumuladoVsDespachado.vue?vue&type=style&index=0&id=94c4fcae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94c4fcae",
  null
  
)

export default component.exports